<hb-modal-dialog heading="{{'AboutDialog.AboutDialogTitle' |i18next }}">
  <div content>
    <div id="logo">
      <div class="app-logo-black-tag"></div>
      <div>{{'AboutDialog.Version' | i18next: {value: version } }}</div>
    </div>

    <div class="misc-links text-center d-flex justify-content-around">
      <span *ngFor="let item of aboutItems" style="padding: 5px 10px;">
        <ng-container *ngIf="item.link">
          <a target="_blank" [href]="boldDeskEnabled && item.boldDesk_Link ? item.boldDesk_Link : item.link">{{ item.name }}</a>
        </ng-container>
        <ng-container *ngIf="!item.link">
          {{ item.value }}
        </ng-container>
      </span>
    </div>

    <div id="copyright">
      {{'AboutDialog.Copyright' | i18next: {value: currentYear } }}
    </div>
  </div>
</hb-modal-dialog>
